export const PAGE_TYPE = {
  'manage-appointment/appointment-management': 'care|faults|Appointment - information',
  '/support/help/broadband/manage-appointment/appointment-management': 'care|faults|Appointment - information',
  '/help/broadband/manage-appointment/appointment-management': 'care|faults|Appointment - information',
  default: 'care|faults|faults information',
};
